import { AfterViewInit, ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

@Component({
  selector: 'itc-toggle-panel',
  templateUrl: 'toggle-panel.component.html',
  styleUrl: 'toggle-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TogglePanelComponent implements AfterViewInit {
  readonly iconClass = input.required<string>();
  readonly label = input.required<string>();
  readonly disabled = input(false);
  readonly isCollapsed = signal(true);
  readonly isAnimationReady = signal(false);

  ngAfterViewInit(): void {
    requestAnimationFrame(() => {
      this.isAnimationReady.set(true);
    });
  }

  togglePanel(): void {
    if (this.disabled()) {
      return;
    }

    this.isCollapsed.update(collapsed => !collapsed);
  }
}
